import React from "react";
import { NumericFormat } from "react-number-format";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

export interface IFeeDetails {
    index?: number,
    label: string,
    fee: any,
    labelClassName?: string,
    feeClassName?: string
}
export default (props: IFeeDetails) => {
    const { lang } = useLanguage();

    function showByType() {
        if (props.fee === "TBD") {
            return getTranslation(lang).tbd;
        }
        const fee = parseFloat(props.fee).toFixed(2);
        return <NumericFormat value={fee} thousandSeparator={true} prefix={"$"} displayType={"text"} />;
    }

    return (
        <div className="row details pl-0 pr-3 py-1" key={props.index}>
            <div className={`col-8 ${props.labelClassName}`}>{props.label}</div>
            <div className={`col-4 ${props.feeClassName}`}>
                {showByType()}
            </div>
        </div>
    );
};
